<template>
  <li class="certificate-features-form uk-active">
    <div class="card rounded">
      <div class="p-3 d-flex justify-content-between align-items-center">
        <h4 class="mb-0">
          {{ $t("certificate.certificate_feature") }}
        </h4>
        <div class="d-flex align-items-center">
          <input id="status_id" class="mb-0" :checked="formData.status_id" type="checkbox"
                 @change="updateFormData('status_id', $event.target.checked)"/>
          <label class="ml-2 mb-0" for="status_id" style="cursor: pointer;">{{
              formData.status_id ? $t("general.active") : $t("general.passive")
            }}</label>
        </div>
      </div>
      <hr class="m-0"/>
      <div class="course-card-body">
        <form action="" class="regular-form">
          <div class="uk-grid-collapse uk-child-width-1-1@s uk-grid uk-grid-stack" uk-grid="">
            <div class="uk-padding-small position-relative uk-first-column">
              <div class="form-group row mb-0">
                <div class="col-md-6">
                  <label class="col-form-label" for="name">{{
                      $t("certificate.name")
                    }}<span class="required">*</span></label>
                  <input :placeholder="$t('certificate.name')" :value="formData.name" class="form-control"
                         type="text"
                         @input="updateFormData('name', $event.target.value)"/>
                </div>
                <div class="col-md-6">
                  <label class="col-form-label" for="renewal_period">{{ $t("certificate.renewal_period") }}<span
                      class="required">*</span></label>
                  <select id="renewal_period"
                          class="form-control"
                          :value="formData.renewal_type_id"
                          @change="updateFormData('renewal_type_id', $event.target.value)">
                    <option value="1">{{
                        $t("certificate.automatic")
                      }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group row mb-0">
                <div :class="formData.expireable ? 'col-md-6' : 'col-md-12'">
                  <label class="col-form-label" for="name">{{ $t("certificate.validity_period") }}<span
                      class="required">*</span></label>
                  <select :value="formData.expireable" class="form-control"
                          @change="updateFormData('expireable', $event.target.value === 'true')">
                    <option :value="false">{{ $t("certificate.indefinite") }}</option>
                    <option :value="true">{{ $t("certificate.timed") }}</option>
                  </select>
                </div>
                <div v-if="formData.expireable" class="col-md-6">
                  <label class="col-form-label" for="name">{{ $t("general.end_date") }}</label>
                  <input :value="formData.end_date" class="form-control" required=""
                         type="date" @input="updateFormData('end_date', $event.target.value)"/>
                </div>
              </div>

              <div class="form-group row mb-0">
                <div class="col-md-12">
                  <label class="col-form-label">{{
                      $t("certificate.text")
                    }}<span class="required">*</span></label>
                  <textarea :placeholder="$t('certificate.body_text_example')" :value="formData.text"
                            class="form-control"
                            required=""
                            type="text" @input="updateFormData('text', $event.target.value)"/>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">{{
                      $t("certificate.certifying_name")
                    }}</label>
                  <input :placeholder="$t('certificate.certifying_name')" :value="formData.certifying_name"
                         class="form-control"
                         type="text"
                         @input="updateFormData('certifying_name', $event.target.value)"/>
                </div>
                <div class="col-md-6">
                  <label class="col-form-label">{{
                      $t("certificate.certifying_title")
                    }}</label>
                  <input :placeholder="$t('certificate.certifying_title')" :value="formData.certifying_title"
                         class="form-control"
                         type="text"
                         @input="updateFormData('certifying_title', $event.target.value)"/>
                </div>
              </div>
              <div class="form-group row mb-0">
                <div class="col-md-12">
                  <label class="col-form-label">{{ $t("general.certificate_type") }}</label>
                  <MultipleSelectInput :allow-empty="true"
                                       :multiple="true"
                                       :searchable="true"
                                       :show-labels="false"
                                       :taggable="true"
                                       :value="selectedCertificateTypes"
                                       :values="certificateTypeOptions"
                                       label="name"
                                       track-by="id"
                                       @addTag="$emit('handleCertificateTypeTag', $event)"
                                       @input="$emit('update:selectedCertificateTypes', $event)"
                  />
                </div>
              </div>

              <div class="form-group row mb-2">
                <div class="col-md-6">
                  <div class="d-flex align-items-center">
                    <label class="col-form-label" for="mail_notify">
                      {{ $t("certificate.mail_notify") }}</label>
                    <input id="mail_notify" :checked="formData.mail_notify" class="ml-2" type="checkbox"
                           @change="updateFormData('mail_notify', $event.target.checked)"/>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="d-flex align-items-center">
                    <label class="col-form-label" for="shareable">
                      {{ $t("certificate.share_on_social") }}</label>
                    <input id="shareable" :checked="formData.shareable" class="ml-2" type="checkbox"
                           @change="updateFormData('shareable', $event.target.checked)"/>
                  </div>
                </div>

              </div>

              <div v-if="formData.expireable" class="form-group row mb-2">
                <div class="col-md-12">
                  <div class="d-flex align-items-center mb-1">
                    <label class="col-form-label mb-0" for="send_expiry_reminder_day">
                      {{ $t("general.remind_seven_days_ago") }}
                    </label>
                    <i :uk-tooltip="`title: ${$t('general.number_between')}`" class="uil-info-circle ml-2"/>
                  </div>
                  <input id="send_expiry_reminder_day"
                         :value="formData.send_expiry_reminder_day"
                         class="form-control"
                         max="90"
                         min="1"
                         placeholder="1-90"
                         step="1"
                         type="number"
                         @input="updateFormData('send_expiry_reminder_day', parseInt($event.target.value))"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </li>
</template>

<script>
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";

export default {
  name: "CertificateFeaturesForm",
  components: {
    MultipleSelectInput
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    selectedCertificateTypes: {
      type: Array,
      default: () => []
    },
    certificateTypeOptions: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    updateFormData(field, value) {
      this.$emit('update:formData', { ...this.formData, [field]: value });
    }
  }
};
</script>

<style scoped>
.card.rounded {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  margin-bottom: 0;
}
</style>
